import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/about")({
  head: () =>
    buildHead({
      title:
        "About Precision Pavers & Pool Design | Pool & Outdoor Living Experts",
      description:
        "Learn about Precision Pavers & Pool Design — a family-owned outdoor living company serving Fort Lauderdale, Coral Springs, Pembroke Pines, and all of Broward County. Pool remodeling, pavers, deck resurfacing, and more since 1996. Visit our Pompano Beach showroom.",
      path: "/about",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "About Us",
            item: "https://precisionpaverspools.com/about",
          },
        ],
      },
    }),
  component: About,
});
